import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import logoImg from '../img/logo.png';
import ReactTable from "react-table";
import "react-table/react-table.css";
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link} from "react-router-dom";
import {connect} from 'react-redux';


import matchSorter from "match-sorter";

import '../styles/sideProfile.scss';
import {request, update} from '../modules/actions/request';

class ResponseList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.showResponseList = this.showResponseList.bind(this);
        this.getUsername = this.getUsername.bind(this);
    }

    componentDidMount() {
        this.showResponseList();
        // this.getUsername();
    }

    showResponseList() {
        let that = this; //this는 dashboardBuyer component!
        // console.log("this state is what??", this);
        axios.post('https://spice-api.pearlfall.vercel.app'+`/requests/resultList`, {})
            .then(function (response) {
                // console.log('response list', response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    data: response.data.request,
                });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    getUsername(payload){
        let that = this; //this는 dashboardBuyer component!
        // console.log("this state is what??", this);
        let userId = {'id': '5d645615b316993dc0bf36b2'};
        axios.post('https://spice-api.pearlfall.vercel.app'+`/users/getName`, userId)
            .then(function (response) {
                // console.log('response name', response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    dataName: response.data.name,
                });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    render() {
        // console.log("request list", this.state.data);
        return (
            <div className="profile-right">

                <h1 className="text-center">
                    Here are responses from sellers!
                </h1>
                <Row>
                    <Col md={1}></Col>
                    <Col md={10}>
                        <ReactTable style={{"margin-top":"30px"}}
                            data={this.state.data}
                            dataName={this.state.dataName}
                            filterable
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]) === filter.value}
                            columns={[
                                {
                                    Header: "Seller",
                                    id: 'UserId',
                                    accessor: "sellerName",
                                    width: 150,
                                    sortable: true,
                                    filterAll: true,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: [filter.id]}),
                                    // Cell: (data) => {
                                    //     return (
                                    //         <div>{this.getUsername('5d645615b316993dc0bf36b2')}</div>);
                                    // }

                                },
                                {
                                    Header: "Request Date",
                                    id:'RequestDate',
                                    accessor: "date",
                                    width: 150,
                                    sortable: true,
                                    filterAll: true,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: [filter.id]}),
                                    Cell: (data) => {
                                        var date = data.row.RequestDate;
                                        return (
                                            <div>{date.slice(0,10)}</div>);
                                    }

                                },
                                {
                                    Header: "Response",
                                    accessor: "status",
                                    width: 150,
                                    sortable: true,
                                    filterAll: true,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: [filter.id]}),

                                },

                            ]}
                            defaultPageSize={5}
                            className="-striped -highlight"
                        />
                    </Col>
                    <Col md={1}></Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user
    };
}


export default withRouter(connect(mapStateToProps)(ResponseList));
